import { Home } from "lucide-react";
import { ADMIN_DOMAIN_NAV, resolveAdminDomain, type AdminDomainId, type AdminTabId } from "./admin-nav";
import { cn } from "@/lib/utils";

/** Destinos curados para mobile — el resto se alcanza desde el Hub. */
const BOTTOM_NAV_DOMAIN_IDS: AdminDomainId[] = ["dashboard", "negocio", "cobros", "operaciones"];

type Props = {
  tab: AdminTabId;
  pathname: string;
  onTabChange: (id: AdminTabId) => void;
  leadsPending?: number;
};

export function AdminBottomNav({ tab, pathname, onTabChange, leadsPending }: Props) {
  const activeDomain = resolveAdminDomain({ tab, pathname });
  const domainItems = BOTTOM_NAV_DOMAIN_IDS.map((id) => ADMIN_DOMAIN_NAV.find((d) => d.id === id)).filter(
    (d): d is (typeof ADMIN_DOMAIN_NAV)[number] => Boolean(d),
  );

  return (
    <nav
      className="fixed bottom-0 left-0 z-40 flex w-full items-center justify-around border-t border-sidebar-border bg-sidebar px-1 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 md:hidden"
      aria-label="Navegación principal de Admin"
    >
      <button
        type="button"
        onClick={() => onTabChange("hub")}
        className={cn(
          "flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-2 py-1 transition-transform active:scale-95",
          tab === "hub" ? "bg-primary/10 text-primary" : "text-muted-foreground hover:text-primary",
        )}
      >
        <Home className="h-5 w-5" />
        <span className="max-w-[4.5rem] truncate text-[10px] font-medium">Hub</span>
      </button>
      {domainItems.map(({ id, label, icon: Icon, targetTab }) => {
        const active = activeDomain === id && tab !== "hub";
        return (
          <button
            key={id}
            type="button"
            onClick={() => onTabChange(targetTab)}
            className={cn(
              "relative flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-2 py-1 transition-transform active:scale-95",
              active ? "bg-primary/10 text-primary" : "text-muted-foreground hover:text-primary",
            )}
          >
            <Icon className="h-5 w-5" />
            {id === "negocio" && leadsPending != null && leadsPending > 0 && (
              <span className="absolute right-2 top-0 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[9px] font-semibold text-primary-foreground">
                {leadsPending}
              </span>
            )}
            <span className="max-w-[4.5rem] truncate text-[10px] font-medium">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
